"use strict"

/************ CONTEUDO ***************
 *  01. MULTISTEP FORM
    02. HEADER
    03. SLIDERS
    04. Add Classes
    05. FAQ
    06. FAQ - SEARCH
    07. MODAL
    08. CHANGE IMAGE PRODUCT
    09. VERIFY INPUTS
    10. CHANGE NAME SELECT
    11. SET ANEXO MARKTPLACE
    12. REDIRECT FORM
    13. GET URL IN PUT
    14. SUB MENU

**********************************************/
const location_page = window.location.pathname;
const search = window.location.search;
const screen_width = screen.width;
const header_mobile = document.querySelector('.header__content');
const header_opacity = document.querySelector('.header__opacity');
const header_btn_close = document.querySelector('.header__content-btn-close');
const header_btn_mobile = document.querySelector('.header__btn-mobile');
const header_links = document.querySelectorAll('.header__items li');

const foryou_img = document.querySelectorAll('.foryou__bg-img');
const faqItems = document.querySelectorAll('.faq .faq__item');

let modal = document.querySelector('.modal')
let modal_open = document.querySelector('.header__info-item--search')
let modal_close = document.querySelector('.modal__close')

//Muda nome do primeiro option dos forms e de acordo se está em localhost ou no servidor

if (location_page == '/fale-conosco/' || location_page == '/eazygo/fale-conosco/') {
    document.querySelector('select[name="setor"]').options[0].innerHTML = "QUAL SETOR DA SUA DÚVIDA *";
    document.querySelector('select[name="solicitacao"]').options[0].innerHTML = "QUAL TIPO DE SOLICITAÇÃO *";
}
else if (location_page == '/quero-contratar-vtex/' || location_page == '/eazygo/quero-contratar-vtex/') {
    document.querySelector('select[name="possui-ecommerce"]').options[0].innerHTML = "POSSUI E-COMMERCE *";
}

if (location_page == '/es/habla-con-nosotros/' || location_page == '/eazygo/es/habla-con-nosotros/') {
    document.querySelector('select[name="setor"]').options[0].innerHTML = "TIPO DE DUDA";
    document.querySelector('select[name="solicitacao"]').options[0].innerHTML = "TIPO DE SOLICITUD";
}

/*MULTISTEP FORM**********************************************/
$(function () {
    // SmartWizard initialize

    $('#multipassos').smartWizard({
        enableUrlHash: false,
        toolbar: {
            position: 'bottom',
        },
        lang: { // Language variables for button
            next: 'Próximo',
            previous: 'Anterior'
        },
    });
});


setTimeout(() => {
    let nextStep = document.querySelectorAll('.sw-btn');
    nextStep.forEach(item => {
        item.addEventListener('click', () => {
            window.location = '#multipassos';
        })
    })

    $('#multipassos').on("showStep", (e, anchorObject, stepIndex, stepDirection, stepPosition) => {
        if (stepIndex == 0) {
            $('.sw-toolbar-elm').css('display', 'flex')
            $('.sw-toolbar-elm').css('justify-content', 'end')
        } else if (stepIndex == 3) {
            $('.sw-toolbar-elm').css('display', 'none')
        } else {
            $('.sw-toolbar-elm').css('display', 'flex')
            $('.sw-toolbar-elm').css('justify-content', 'center')
        }
    })
}, 700);


/*Header**********************************************/
header_btn_close?.addEventListener('click', () => {
    toggleMenu()
})

header_btn_mobile?.addEventListener('click', () => {
    toggleMenu()
})

function toggleMenu() {
    if (screen_width < 1269) {
        header_mobile.classList.toggle('header__content--show');
        showOpacity()
        overflowNone()
    }
}

function showOpacity() {
    header_opacity.classList.toggle('header__opacity--show');
}

function overflowNone() {
    document.querySelector("body").classList.toggle('overflow-none');
    document.querySelector("html").classList.toggle('overflow-none');
}

header_links.forEach(item => {
    item.addEventListener('click', () => {
        if (!item.classList.contains('menu-item-has-children')) {
            header_btn_close.click();
        }
    })
})

/*Sliders**********************************************/
if (screen_width < 576) {
    $('.achievements__carrousel').slick({
        infinite: true,
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 3000,
    });

    $('.clients__carrousel').slick({
        slidesToShow: 3,
        variableWidth: true,
        slidesToScroll: 3,
        infinite: true,
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 3000,
    });
}

$('.banner__layer').slick({
    infinite: true,
    arrows: true,
    dots: false,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    nextArrow: '<div class="slick-next">  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="32"><path d="M13.1714 12.0007L8.22168 7.05093L9.63589 5.63672L15.9999 12.0007L9.63589 18.3646L8.22168 16.9504L13.1714 12.0007Z" fill="rgba(255,255,255,1)"></path></svg> </div>',
    prevArrow: '<div class="slick-prev">  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="32"><path d="M10.8284 12.0007L15.7782 16.9504L14.364 18.3646L8 12.0007L14.364 5.63672L15.7782 7.05093L10.8284 12.0007Z" fill="rgba(255,255,255,1)"></path></svg> </div>'
});

/*Add Classes**********************************************/
foryou_img.forEach((item, index) => {
    if (index % 2 !== 0) {
        item.classList.add('foryou__bg-img--par')
    }
});

/*FAQ**********************************************/
faqItems.forEach(el => {
    el.querySelector('.faq__header').addEventListener('click', () => {

        if (el.classList.contains('active')) {
            el.classList.remove('active');
        } else {
            faqItems.forEach(element => {
                element.classList.remove('active');
            })
            el.classList.add('active');
        }
    })
})

/*FAQ - SEARCH **********************************************/
function FiltrarPergunta(pergunta) {
    let input = document.querySelector(".busca").value.toUpperCase();
    let li = document.querySelectorAll(".faq__header");
    li.forEach((item, index) => {
        console.log(index)
        let txtValue = item.textContent || item.innerText;
        if (txtValue.toUpperCase().indexOf(input) > -1) {
            item.parentElement.style.display = "";
        } else {
            item.parentElement.style.display = "none";
        }
    })
}


/*MODAL **********************************************/
if (modal_open) {
    modal_open.onclick = () => {
        modal.style.display = "flex";
        toggleMenu()
    }
}

if (modal_close) {
    modal_close.onclick = function () {
        modal.style.display = "none";
    }
}

window.onclick = (event) => {
    if (event.target == modal) {
        modal.style.display = "none";
    }
}

/*CHANGE IMAGE PRODUCT **********************************************/
function changeImagePage(evt, pag) {
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("make__deliver-content");
    for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("make__deliver-nav");
    for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    document.getElementById(pag).style.display = "block";
    evt.currentTarget.className += " active";
}
let clickChange = document.querySelector(".make__deliver-nav")
if (clickChange) {
    document.querySelector(".make__deliver-nav").click();
}

/*VERIFY INPUTS **********************************************/
let btn_submit_home = document.querySelector('.btn-submit--home');
if (btn_submit_home) {
    btn_submit_home.disabled = true;
}

let inputs = $('.input-home').on('keyup', verificarInputs);
let select_home = $(".input-select-home").on("change", verificarInputs);

function verificarInputs() {
    const preenchidos = inputs.get().every(({ value }) => value)

    if (preenchidos == true && select_home.val() !== '') {
        $('.btn-submit--home').prop('disabled', false);
    }
    else {
        $('.btn-submit--home').prop('disabled', true);
        console.log(' inputs preenehcidos')
    }

}

let btn_submit_contact = document.querySelector('.btn-submit--contact');
if (btn_submit_contact) {
    btn_submit_contact.disabled = true;
}

let inputs_contact = $('.input-contact').on('keyup', verificarInputsContact);

function verificarInputsContact() {
    const preenchidos = inputs_contact.get().every(({ value }) => value)

    if (preenchidos == true) {
        $('.btn-submit--contact').prop('disabled', false);
    }
    else {
        $('.btn-submit--contact').prop('disabled', true);
        console.log(' inputs preenehcidos 2')
    }
}

/*CHANGE NAME SELECT **********************************************/
let select_segment = document.querySelectorAll('select[name="tipo-de-projeto"]')
select_segment.forEach(item => {
    item.options[0].innerHTML = "TIPO DE PROJETO *";
})

let select_segment_es = document.querySelectorAll('select[name="tipo-de-proyecto"]')
if (select_segment_es) {
    select_segment_es.forEach(item => {
        item.options[0].innerHTML = "TIPO DE PROYECTO *";
    })
}

/*SET ANEXO MARKTPLACE *********************************************/
/*let descritivo_anexo = document.querySelector('input[name="descritivo-anexo"]')*/

let select_modelo = document.querySelector('select[name="modelo-venda"]')
if (select_modelo) {
    select_modelo.options[0].innerHTML = "MODELO DE VENDA *";
}


/*REDIRECT FORM **********************************************/
document.addEventListener('wpcf7mailsent', function (event) {
    if ('36' == event.detail.contactFormId) {
        setTimeout(() => {
            location = 'https://eazygo.com.br/contratar/';
        }, 4000);
    }
}, false);

document.addEventListener('wpcf7mailsent', function (event) {
    if ('105' == event.detail.contactFormId) {
        document.querySelector('.file-name').textContent = 'Anexar arquivo';
    }
}, false);


/*GET URL IN PUT **********************************************/
const urlPage = document.querySelector('.name-url-global');
if (urlPage) {
    urlPage.value = location_page;
}

/*SUB MENU **********************************************/
const itemMenu = document.querySelectorAll('.menu-item-has-children');

itemMenu.forEach(function (el) {
    el.addEventListener('click', function () {
        if (window.innerWidth <= 768) {
            el.classList.toggle('open');
        }
    })
})

// newhome
// Menu
window.addEventListener('load', function () {
    const hamburguerItem = document.querySelector('.n-main-header__hamburguer');
    const headerMenus = document.querySelector('.n-main-header__items');
    const menuSecundario = document.querySelector('.n-main-header__menu--secundary');
    if (hamburguerItem) {
        hamburguerItem.addEventListener('click', (e) => {
            hamburguerItem.classList.toggle('active');
            headerMenus.classList.toggle('active');
            menuSecundario.classList.toggle('active');
        })
    }
})

$('.n-main-banner__list').slick({
    infinite: true,
    dots: false,
    autoplay: true,
    autoplaySpeed: 3500,
    slidesToShow: 1,
    slide: '.n-main-banner__item',
    prevArrow: $('.n-main-banner__arrow--prev'),
    nextArrow: $('.n-main-banner__arrow--next'),
});

$('.cards-slider__list.cards-slider__list--1').slick({
    infinite: true,
    dots: false,
    autoplay: true,
    autoplaySpeed: 3500,
    slidesToShow: 1,
    slide: '.cards-slider__item',
    prevArrow: $('.cards-slider__list--1 .cards-slider__arrow--prev'),
    nextArrow: $('.cards-slider__list--1 .cards-slider__arrow--next'),
    variableWidth: true
});

$('.cards-slider__list.cards-slider__list--2').slick({
    infinite: true,
    dots: false,
    autoplay: true,
    autoplaySpeed: 3500,
    slidesToShow: 1,
    slide: '.cards-slider__item',
    prevArrow: $('.cards-slider__list--2 .cards-slider__arrow--prev'),
    nextArrow: $('.cards-slider__list--2 .cards-slider__arrow--next'),
    variableWidth: true
});

$('.vtex-infos__benefits').slick({
    infinite: false,
    dots: true,
    autoplay: true,
    autoplaySpeed: 3500,
    slidesToShow: 1,
    slide: '.vtex-infos__item',
    prevArrow: $('.vtex-infos__arrow--prev'),
    nextArrow: $('.vtex-infos__arrow--next'),
    variableWidth: true,
    mobileFirst: true,
    responsive: [
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                variableWidth: false,
            }
        },
        {
            breakpoint: 1023,
            settings: "unslick"
        },
    ]
});

$('.testimonials__list').slick({
    infinite: true,
    dots: false,
    autoplay: true,
    autoplaySpeed: 3500,
    slidesToShow: 1,
    slide: '.testimonials__item',
    variableWidth: true,
    mobileFirst: true,
    arrows: false,
});

$('.products__list').slick({
    infinite: true,
    dots: false,
    autoplay: true,
    autoplaySpeed: 3500,
    slidesToShow: 1,
    slide: '.products__item',
    variableWidth: true,
    mobileFirst: true,
    arrows: false,
    responsive: [
        {
            breakpoint: 1023,
            settings: "unslick"
        },
    ]
});

// modal produtos
document.addEventListener('DOMContentLoaded', () => {
    const body = document.body;
    const modalContainer = document.querySelector('.products');

    if (!modalContainer) return;

    modalContainer.addEventListener('click', (event) => {
        const openButton = event.target.closest('.products__item--link');
        const closeButton = event.target.closest('.products__item-modal--close');

        if (openButton) {
            openModal(openButton.dataset.open);
        } else if (closeButton) {
            closeModal(closeButton.dataset.close);
        }
    });

    function openModal(itemId) {
        const modal = document.querySelector(`.products__item-modal[data-item="${itemId}"]`);
        if (modal) {
            modal.classList.add('active');
            body.classList.add('stop-scroll');
        }
    }

    function closeModal(itemId) {
        const modal = document.querySelector(`.products__item-modal[data-item="${itemId}"]`);
        if (modal) {
            modal.classList.remove('active');
            body.classList.remove('stop-scroll');
        }
    }
});

$('.pioneers__slider').slick({
    infinite: true,
    dots: false,
    autoplay: true,
    autoplaySpeed: 3500,
    slidesToShow: 1,
    variableWidth: false,
    mobileFirst: true,
    arrows: false,
});

$('.pioneers__line').slick({
    infinite: true,
    dots: false,
    autoplay: true,
    autoplaySpeed: 3500,
    slidesToShow: 1,
    variableWidth: true,
    mobileFirst: true,
    arrows: false,
    responsive: [
        {
            breakpoint: 1023,
            settings: "unslick"
        },
    ]
});

$('.n-clients__list').slick({
    infinite: true,
    dots: false,
    autoplay: true,
    autoplaySpeed: 3500,
    slidesToShow: 2,
    variableWidth: false,
    mobileFirst: true,
    arrows: false,
    responsive: [
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 4,
            }
        },
        {
            breakpoint: 1023,
            settings: "unslick"
        },
    ]
});

const preClickMenuMobile = document.querySelectorAll('.n-main-header__menu-item a.has-sub');

preClickMenuMobile.forEach(function (el) {
    el.addEventListener('click', function (e) {
        if (window.innerWidth <= 1024) {
            if (!el.classList.contains('clicked')) {
                e.preventDefault();
                el.classList.toggle('clicked')
            }
            else el.classList.toggle('clicked')
        }
    })
})